var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconThreeDotVh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 65,
    viewBox: "0 0 29 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 65,
    rx: 10,
    fill: "#130F40",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 25.353C13.0396 25.353 11.8557 24.1691 11.8557 22.7086C11.8557 21.2482 13.0396 20.0643 14.5 20.0643C15.9605 20.0643 17.1444 21.2482 17.1444 22.7086C17.1444 24.1691 15.9605 25.353 14.5 25.353Z",
    fill: "#5A577A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 35.1377C13.0396 35.1377 11.8557 33.9538 11.8557 32.4934C11.8557 31.0329 13.0396 29.849 14.5 29.849C15.9605 29.849 17.1444 31.0329 17.1444 32.4934C17.1444 33.9538 15.9605 35.1377 14.5 35.1377Z",
    fill: "#5A577A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 44.9215C13.0396 44.9215 11.8557 43.7375 11.8557 42.2771C11.8557 40.8166 13.0396 39.6327 14.5 39.6327C15.9605 39.6327 17.1444 40.8166 17.1444 42.2771C17.1444 43.7375 15.9605 44.9215 14.5 44.9215Z",
    fill: "#5A577A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThreeDotVh);
export default __webpack_public_path__ + "static/media/icon-three-dot-vh.52b8d3701b54301369a8a253fa2f9e1b.svg";
export { ForwardRef as ReactComponent };